module.exports = __webpack_public_path__ + "img/004-xlsx.d77a4f94.svg";